<script setup>
import Card from '@/components/Shared/Card.vue';
import { inject } from 'vue';
import moment from 'moment';

const props = defineProps({
  ticket: {
    type: Object,
    required: true,
  },
  isPartner: {
    type: Boolean,
    default: false,
  },
});

const trans = inject('trans');
</script>

<template>
  <card>
    <template #body>
      <div>
        <strong>{{ trans('__JSON__.Ticket Information') }}</strong>
      </div>
      <div class="mt-4 mb-2">
        <strong>{{ trans('__JSON__.Ticket number') }}:</strong>
        <p>{{ ticket.id }}</p>
      </div>
      <div class="mt-4 mb-2">
        <strong>{{ trans('__JSON__.Created by') }}:</strong>
        <p>{{ ticket.user.name }}</p>
      </div>
      <div class="mt-4 mb-2">
        <strong>{{ trans('__JSON__.Ticket for') }}:</strong>
        <p>{{ ticket.sendTo.user.name }}</p>
      </div>
      <div class="mt-4 mb-2">
        <strong>{{ trans('__JSON__.Created on') }}:</strong>
        <p>{{ moment(ticket.dateCreated).format('MMM DD, YYYY, h:mm:ss A') }}</p>
      </div>
      <div class="my-4">
        <strong>{{ trans('__JSON__.Request type') }}:</strong>
        <p>{{ ticket.requestType }}</p>
      </div>
      <div class="my-4">
        <strong>{{ trans('__JSON__.Impact') }}:</strong>
        <p>{{ ticket.impact }}</p>
      </div>
      <div class="my-4">
        <strong>{{ trans('__JSON__.Urgency') }}:</strong>
        <p>{{ ticket.urgency }}</p>
      </div>
      <div class="my-4">
        <strong>{{ trans('__JSON__.Priority') }}:</strong>
        <p>{{ ticket.priority }}</p>
      </div>
      <div class="my-4">
        <strong>{{ trans('__JSON__.Has workaround available') }}:</strong>
        <p>{{ ticket.hasWorkaroundAvailable ? trans('__JSON__.Yes') : trans('__JSON__.No') }}</p>
      </div>
      <div v-if="ticket.application1" class="my-4">
        <strong>{{ trans('common.application') }} 1:</strong>
        <p>{{ ticket.application1?.name }}</p>
      </div>
      <div v-if="ticket.application2" class="my-4">
        <strong>{{ trans('common.application') }} 2:</strong>
        <p>{{ ticket.application2.name }}</p>
      </div>
      <div class="my-4">
        <strong>{{ trans('__JSON__.Assignee') }}:</strong>
        <p>{{ ticket.assignee }}</p>
      </div>
    </template>
  </card>
</template>
